import ready, { HTML } from './utils';
import initMobileMenu from './components/mobileMenu';
import initOpenClose from './components/openClose';
import initSearchPopup from './components/searchPopup';
import initModal from './components/modal';
import initTabs from './components/tabs';
import initTooltip from './components/tooltip';
import initMultiselect from './components/multiselect';
import initShowPassword from './components/showPassword';
import initRange from './components/range';

ready(() => {
  HTML.classList.add('is-loaded');
  initMobileMenu();
  initOpenClose();
  initSearchPopup();
  initModal();
  initTabs();
  initTooltip();
  initMultiselect();
  initShowPassword();
  initRange();
});
